<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 mat-dialog-title>Accion realizada :: <strong>{{action}}</strong></h1>
<div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form [formGroup]="form">
        <mat-form-field *ngIf="action != 'Eliminar'; else elseTemplate">
            <input cdkFocusInitial formControlName="Descripcion" placeholder="{{action}} Descripcion" matInput [(ngModel)]="local_data.descripcion">
            <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.
            </mat-error>
        </mat-form-field>
    </form>
    <ng-template #elseTemplate>
        ¿Esta seguro que desea eliminar el registro <b>{{local_data.descripcion}}</b>?
    </ng-template><br>
</div>
<mat-divider></mat-divider>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" *appRole="['TiposFolio.Crear','TiposFolio.Modificar','TiposFolio.Eliminar']" (click)="doAction()" [disabled]="!form.valid">{{action}}</button>
    <button mat-button (click)="closeDialog()" color="warn">Cancelar</button>
</div>
